import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import useErrorInfoModal from '@features/modal/hooks/useErrorInfoModal'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'

type ErrorInfoModalProps = {
  extendedErrorMessage?: string;
}

export default function ErrorInfoModal ({ extendedErrorMessage }: ErrorInfoModalProps) {
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { t: tc } = useTranslation('common')
  const { closeErrorInfoModal } = useErrorInfoModal()

  return (
    <div>
      {extendedErrorMessage && <details className={styles.details}>
        <summary>
          {tc('error-boundary.show-details')}
        </summary>
        <pre>
          {extendedErrorMessage}
        </pre>
      </details>}
      <Button
        size={isTablet ? 'large' : 'medium'}
        className={styles['bottom-button-close']}
        onClick={closeErrorInfoModal}
      >
        {tc('close')}
      </Button>
    </div>
  )
}
